var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaskGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 144,
    viewBox: "0 0 201 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3997_7120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 4,
    width: 191,
    height: 135
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2191 84.4277C6.06543 77.5992 6.06543 66.1792 13.2191 59.3507C19.9173 52.957 30.458 52.957 37.1562 59.3507L62.9674 83.9886C69.9231 90.6281 80.8689 90.6281 87.8246 83.9886L163.844 11.4245C170.542 5.03081 181.083 5.03082 187.781 11.4246C194.935 18.253 194.935 29.6731 187.781 36.5016L87.8245 131.915C80.8689 138.554 69.9231 138.554 62.9674 131.915L13.2191 84.4277Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3997_7120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-20 -25.1328C-20 -35.0739 -11.9411 -43.1328 -2 -43.1328H203C212.941 -43.1328 221 -35.0739 221 -25.1328V168.913C221 178.854 212.941 186.913 203 186.913H-2C-11.9411 186.913 -20 178.854 -20 168.913V-25.1328Z",
    fill: "#1165BA"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaskGroup);
export default __webpack_public_path__ + "static/media/mask-group.7e6ac4eed9805744817d88a4c31db041.svg";
export { ForwardRef as ReactComponent };